import React from "react";
import "../style/LoadingScreen.css";

/**
 * Covers the gap until the first hero photograph is decoded. It is tied to a
 * real event rather than a timer, so it never pads the wait artificially.
 */
export default function LoadingScreen({ title }: { title: string }) {
  return (
    <div className="loading" role="status" aria-live="polite">
      <span className="loading__title">{title}</span>
      <span className="loading__bar" aria-hidden="true" />
      <span className="visually-hidden">Yükleniyor</span>
    </div>
  );
}
